import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ToasterService} from "../../../../../services/core/toaster.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProductDataService} from "../../product.data.service";
import {first} from "rxjs/operators";

@Component({
    selector: 'app-add-manufacturer',
    templateUrl: './add-manufacturer.component.html',
    styleUrls: ['./add-manufacturer.component.scss'],
    standalone: false
})
export class AddManufacturerComponent implements OnInit {

  public sectionForm!: UntypedFormGroup;
  constructor(
    public toasterService: ToasterService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public productDataService: ProductDataService,
    public dialogRef: MatDialogRef<AddManufacturerComponent>,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }
  initForm(){
    this.sectionForm = new UntypedFormGroup({
      name: new UntypedFormControl('' , [Validators.required]),
      prefix: new UntypedFormControl('' , []),
      status: new UntypedFormControl(1 , ),
    });
  }

  onConfirm = () => {
    if (this.sectionForm.invalid) {
      this.touchFormControls();
      return
    }
    this.productDataService.createManufacturer(this.sectionForm.value)
      .pipe(first())
      .subscribe(
        data => {
          this.close(data);
          this.toasterService.showSuccessMessage(data?.data?.message);
        });
  }
  touchFormControls(){
    Object.keys(this.sectionForm.controls).forEach(key => {
      this.sectionForm.get(key)?.markAsTouched();
    });
  }
  close = (data: any = null) => {
    this.dialogRef.close(data);
  }

}
